export class Usager {
  Id: string;
  Email: string;
  PhoneNumber: string;
  UserName: string;
  PinCode: string;
  IsEnabled: boolean;
  UserRoles: string[];
}
